import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import DataTable from "react-data-table-component";
import dayjs from "dayjs";

//internal import
import PageHeader from "../../components/common/PageHeader";
import useEmployeeLeaveSubmit from "../../hooks/useEmployeeLeaveSubmit";
import InputArea from "../../components/Input/InputArea";
import Error from "../../components/Input/Error";
import ModalLoading from "../../components/Loading/ModalLoading";
import useAsync from "../../hooks/useAsync";
import EmployeeLeaveService from "../../services/EmployeeLeaveService";
import DropDownService from "../../services/DropDownService";
import { useLocation } from 'react-router-dom';

function LeaveRequest() {

    const [employeeLeaveId, setEmployeeLeaveId] = useState("");

    const { data, loading } = useAsync(() => EmployeeLeaveService?.getAllEmployeeLeave());
    const { data: employeeData, loading: employeeLoading } = useAsync(() => DropDownService.employeeDropDown());
    const location = useLocation();
    const { pathname } = location; 
    const { data:permissionData } = useAsync(() => DropDownService.getModulePermissions({ path:pathname, userId:localStorage.id})); 
    var addPermission = typeof permissionData?.data?.add === 'undefined' ? 1: permissionData?.data?.add; 
    var viewPermission = typeof permissionData?.data?.view === 'undefined' ? 1: permissionData?.data?.view;
    var editPermission = typeof permissionData?.data?.edit === 'undefined' ? 1: permissionData?.data?.edit; 
    var deletePermission = typeof permissionData?.data?.delete === 'undefined' ? 1: permissionData?.data?.delete; 
    var listPermission = typeof permissionData?.data?.list === 'undefined' ? 1: permissionData?.data?.list;

    const {
        register,
        handleSubmit,
        errors,
        onSubmit,
        handleDeleteEmployeeLeave,
        handleManageEmployeeLeave,
        isModal,
        setIsModal,
        isViewModal,
        setIsViewModal,
        isDeleteModal,
        setIsDeleteModal,
        employeeApproveModal,
        setEmployeeApproveModal,
        employeeRejectModal,
        setEmployeeRejectModal,
        viewData } = useEmployeeLeaveSubmit(employeeLeaveId);

    var columnT = "";
    columnT = [
        {
            name: "EMPLOYEE ID",
            selector: row => row.employee.employeeId,
            sortable: true,
            minWidth: "130px",
            cell: row => <a href="members-profile" className="fw-bold text-secondary">{row.employeeId.employeeCode}</a>
        },
        {
            name: "NAME",
            selector: row => { },
            sortable: true,
            cell: row => <div>
                <b className="fw-bold ms-1">{row.employeeId.employeeName}</b>
            </div>
        },
        {
            name: "TYPE",
            wrap: true,
            selector: row => row.leaveType,
            sortable: true
        },
        {
            name: "FROM",
            selector: row => dayjs(row.leaveFrom).format('DD-MM-YYYY'),
            sortable: true
        },
        {
            name: "TO",
            selector: row => dayjs(row.leaveTo).format('DD-MM-YYYY'),
            sortable: true
        },
        {
            name: "REASON",
            selector: row => row.reason,
            sortable: true
        },
        {
            name: "STATUS",
            selector: row => <div className={`p-2 badge ${row.status === "Approved" ? 'bg-success' : row.status === "Rejected" ? "bg-danger" : "bg-warning"}`}>{row.status}</div>,

            sortable: true
        },
        {
            name: "MANAGE",
            selector: row => { },
            sortable: true,
            minWidth: "220px",
            cell: (row) => row.status !== "Approved" && row.status !== "Rejected" ?
                <div className="btn-group" role="group" aria-label="Basic outlined example" >
                    <button type="button" className="btn btn-outline-secondary" onClick={() => { handleManageEmployeeLeave(row._id, "Approved") }}>Approve <i className="icofont-check-circled text-success"></i></button>
                    <button type="button" className="btn btn-outline-secondary deleterow" onClick={() => { handleManageEmployeeLeave(row._id, "Rejected") }}>Reject <i className="icofont-close-circled text-danger"></i></button>
                </div> : <div className="text-center  w-100">-</div>
        },
        {
            name: "ACTION",
            selector: row => { },
            sortable: true,
            minWidth: "150px",
            cell: (row) => (<div className="btn-group" role="group" aria-label="Basic outlined example">
                {viewPermission === 1 && (<button type="button" className="btn btn-outline-secondary" onClick={() => { setIsViewModal(true); setEmployeeLeaveId(row?._id) }} ><i className="icofont-eye-alt text-primary"></i></button>)}
                {editPermission === 1 && (<button type="button" className="btn btn-outline-secondary" onClick={() => { setIsModal(true); setEmployeeLeaveId(row?._id); }}><i className="icofont-edit text-success"></i></button>)}
                {deletePermission === 1 && (<button type="button" className="btn btn-outline-secondary deleterow" onClick={() => { setIsDeleteModal(true); setEmployeeLeaveId(row?._id) }} ><i className="icofont-ui-delete text-danger"></i></button>)}
            </div>)
        }
 
    ]
    const customStyles = {
        cells: {
            style: {
                whiteSpace: 'normal',
                wordBreak: 'break-word',
            },
        },
    };

    return (
        <div className="container-xxl">
            {loading ? <ModalLoading loading={loading} /> :
                <>
                    <PageHeader addPermission={addPermission} headerTitle="Leave Request" renderRight={() => {
                        return <div className="col-auto d-flex w-sm-100">
                            <button className="btn btn-dark btn-set-task w-sm-100" onClick={() => { setIsModal(true); setEmployeeLeaveId(""); }}><i className="icofont-plus-circle me-2 fs-6"></i>Add Leave</button>
                        </div>
                    }} />
                    {listPermission === 1 && (
                    <div className="row clearfix g-3">
                        <div className="col-sm-12">
                            <DataTable
                                title={"Employee Leave"}
                                columns={columnT}
                                data={data.data}
                                defaultSortField="title"
                                pagination
                                selectableRows={false}
                                className="table myDataTable table-hover align-middle mb-0 d-row nowrap dataTable no-footer dtr-inline"
                                highlightOnHover={true}
                                customStyles={customStyles}
                            />
                        </div>
                    </div>
                    )}
                </>
            }

            {/* leave request view modal */}
            <Modal show={isViewModal} size="lg" centered onHide={() => { setIsViewModal(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">Holidays Detail</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <div className="modal-body">
                        <div className="deadline-form">
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Employee Id </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.employeeId?.employeeCode}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Employee Name </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.employeeId?.employeeName}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Reason </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.reason}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> From </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{dayjs(viewData?.leaveFrom).format("DD-MM-YYYY")}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> To </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{dayjs(viewData?.leaveTo).format("DD-MM-YYYY")}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> No of Days</b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{dayjs(viewData?.leaveTo).diff(viewData?.leaveFrom, "day") + 1}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Leave Type</b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.leaveType}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {/* leave request add and edit modal */}
            <Modal centered show={isModal} onHide={() => { setIsModal(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">{employeeLeaveId ? "Edit" : "Add"} Leave</Modal.Title>
                </Modal.Header>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Modal.Body>
                        <div className="mb-3">
                            <label className="form-label">Select Employee </label>
                            <select className="form-select" {...register(`employeeId`, { required: `Employee Type is required!` })}>
                                <option value="" defaultValue >Select Employee</option>
                                {!employeeLoading && employeeData?.data?.map((employee, index) => (
                                    <option key={index} value={employee?.value}>{employee?.label}</option>
                                ))}
                            </select>
                            <Error errorName={errors?.employeeId} />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Select Leave type</label>
                            <select className="form-select" {...register(`leaveType`, { required: `Leave Type is required!` })}>
                                <option value="" defaultValue >Select Leave type</option>
                                <option value="Medical Leave" >Medical Leave</option>
                                <option value="Casual Leave">Casual Leave</option>
                                <option value="Maternity Leave">Maternity Leave</option>
                            </select>
                            <Error errorName={errors?.leaveType} />
                        </div>
                        <div className="deadline-form">
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <label htmlFor="datepickerdedass" className="form-label">Leave From Date</label>
                                    <InputArea register={register} name="leaveFrom" type="date" className="form-control" id="datepickerdedass" />
                                    <Error errorName={errors?.leaveFrom} />
                                </div>
                                <div className="col-sm-6">
                                    <label htmlFor="datepickerdedoneddsd" className="form-label">Leave to Date</label>
                                    <InputArea register={register} name="leaveTo" type="date" className="form-control" id="datepickerdedoneddsd" />
                                    <Error errorName={errors?.leaveTo} />
                                </div>
                            </div>
                        </div>
                        <div className="mb-3">
                            <label htmlFor="exampleFormControlTextarea78d" className="form-label">Leave Reason</label>
                            <textarea {...register(`reason`, { required: "Reason is required!" })} className="form-control" id="exampleFormControlTextarea78d" rows="3"></textarea>
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-secondary" onClick={() => { setIsModal(false) }}>Cancel</button>
                        <button type="submit" className="btn btn-primary">{employeeLeaveId ? "Update " : "Add"}</button>
                    </Modal.Footer>
                </form>
            </Modal>
            <Modal centered show={employeeApproveModal} onHide={() => { setEmployeeApproveModal(false) }}>
                <Modal.Header closeButton><h5 className="modal-title  fw-bold" id="dremovetaskLabel"> Leave Approve</h5></Modal.Header>
                <Modal.Body className="justify-content-center flex-column d-flex">
                    <i className="icofont-simple-smile text-success display-2 text-center mt-2"></i>
                    <p className="mt-4 fs-5 text-center">Leave Approve Successfully</p>
                </Modal.Body>
            </Modal>
            <Modal centered show={employeeRejectModal} onHide={() => { setEmployeeRejectModal(false) }}>
                <Modal.Header closeButton><h5 className="modal-title  fw-bold" id="leaverejectLabel"> Leave Reject</h5></Modal.Header>
                <Modal.Body className="justify-content-center flex-column d-flex">
                    <i className="icofont-sad text-danger display-2 text-center mt-2"></i>
                    <p className="mt-4 fs-5 text-center">Leave Rejected</p>
                </Modal.Body>
            </Modal>

            {/* employee leave delete modal */}
            <Modal show={isDeleteModal} centered onHide={() => { setIsDeleteModal(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">Delete EmployeeLeave</Modal.Title>
                </Modal.Header>
                <Modal.Body className="justify-content-center flex-column d-flex">
                    <i className="icofont-ui-delete text-danger display-2 text-center mt-2"></i>
                    <p className="mt-4 fs-5 text-center">Are You Sure! Want to Delete EmployeeLeave ?</p>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={() => { setIsDeleteModal(false) }}>Cancel</button>
                    <button type="button" className="btn btn-danger color-fff" onClick={() => handleDeleteEmployeeLeave(employeeLeaveId)}>Delete</button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}


export default LeaveRequest; 